export default {
  abilities: (state) => {
    return state.abilities;
  },
  isTempPassword: (state) => {
    return state.isTempPassword;
  },
  hasAbility:
    (state) =>
    // eslint-disable-next-line no-unused-expressions
    (area, action) =>
      state.abilities && state.abilities[area]
        ? state.abilities[area].indexOf(action) !== -1
        : false,
  defaultRouter: (state) => {
    return state.defaultPath;
  },
  path: (state) => {
    return state.path;
  },
  loading: (state) => {
    return state.loading;
  },
  overlayInLoading: (state) => {
    return state.overlayInLoading;
  },
  modals: (state) => {
    return state.modals;
  },
  menuItems: (state) => {
    return state.menuItems;
  },
  fullName: (state) => {
    return state.fullName
  },
  originalUser: (state) => {
    return state.originalUser
  }
};
